module.exports = __webpack_public_path__ + "img/04_Screenshot 2025-06-13 at 14.00.58.e7f42d3f.jpg";